/**
 * Returns a validation message based on the type of validation rule and its value.
 *
 * @param {string} key - The type of validation rule.
 * @param {T | Validation<T>} ruleValue - The value of the validation rule, which can be a variety of types.
 * @returns - A string representing the validation message.
 */
export const getValidationMessage = (key, validation) => {
    switch (key) {
        case 'required':
            return 'This field is required';
        case 'pattern':
            return 'The format of this field is invalid';
        case 'minLength':
            return `Value is too short, it must be at least ${validation === null || validation === void 0 ? void 0 : validation.minLength} characters long`;
        case 'maxLength':
            return `Value is too long, it must be no more than ${validation === null || validation === void 0 ? void 0 : validation.maxLength} characters long`;
        case 'min':
            return `Value is too low, it must be greater than or equal to ${validation === null || validation === void 0 ? void 0 : validation.min}`;
        case 'max':
            return `Value is too high, it must be less than or equal to ${validation === null || validation === void 0 ? void 0 : validation.max}`;
        default:
            return 'Invalid value';
    }
};
